module.exports = __webpack_public_path__ + "img/bg.3358a05c.png";